<template>
  <div>
    <div class="text-red-500 text-3xl" v-if="!hasRegistered">
      Velkommen som praksisapotek!
    </div>
       
    <form class="mt-12" @submit.prevent="onSubmit" v-if="pharmacy">

      <div class="flex -mx-4">
        <div class="w-3/5 px-4">
          <div class="mt-6">
            <label class="font-bold" for="name">Navn på apotek:</label>
            <div class="mt-1">
              <input class="w-full" :class="{ 'invalid': nameInvalid }" type="text" id="name" ref="name" v-model="pharmacy.name">
            </div>
          </div>

          <div class="mt-6">
            <label class="font-bold" for="address">Apotekets besøksadresse:</label>
            <div class="mt-1">
              <input class="w-full" :class="{ 'invalid': addressInvalid }" type="text" id="address" ref="address" v-model="pharmacy.address">
            </div>
          </div>

          <div class="flex -mx-4">
            <div class="px-4 w-32 flex-0">
              <div class="mt-6">
                <label class="font-bold" for="postNo">Postnr:</label>
                <div class="mt-1">
                  <input :class="{ 'invalid': postCodeInvalid }" class="w-full" type="text" id="postNo" maxlength="4" ref="postNo" v-model="pharmacy.postCode">
                </div>
              </div>
            </div>
            <div class="px-4">
              <div class="mt-6 flex-1">
                <label class="font-bold" for="postPlace">Sted:</label>
                <div class="mt-1">
                  <input :class="{ 'invalid': postPlaceInvalid }" class="w-full" type="text" id="postPlace" ref="postPlace" v-model="pharmacy.postPlace">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-2/5 px-4">
        <div class="w-full h-56 mt-6">
            <label class="font-bold block mb-1" for="name">Kartplassering:</label>
            <l-map 
              ref="map"           
              :zoom="pharmacy.zoom"
              :center="[pharmacy.latitude, pharmacy.longitude]" 
              v-if="isGeoReady"
              @ready="mapReady"
              @click="onMapClick"
              @zoom="onMapZoom"
            >
              <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
              <l-marker :lat-lng="[pharmacy.latitude, pharmacy.longitude]" :draggable="true" @dragend="onDragEnd"></l-marker>
            </l-map>
          </div>
        </div>
      </div>

      <div class="mt-12">
        <div class="font-semibold">
          For at alle skal få en best mulig opplevelse må praksisapotek ha kjennskap til retningslinjene for Apotekforeningens praksispool.
        </div>
        <div class="mt-8 text-black">
          <checkbox v-model="pharmacy.acceptsTerms">
            Ja, jeg har lest og forstått <a href="https://www.apotek.no/" target="_blank" class="inline-block pb-1 border-b-2 border-red-500 outline-none focus:border-black">retningslinjene for Apotekforeningens praksispool</a>.
          </checkbox>
        </div>
      </div>

      <div class="text-right mt-16">
        <button class="btn btn-primary" type="submit" :disabled="!pharmacy.acceptsTerms">
          <span class="inline-block mr-4">Neste</span> <font-awesome-icon :icon="['far', 'chevron-right']" />
        </button>
      </div>

    </form>
  </div>

</template>

<script>
import api from '@/api'
export default {
  name: 'ap-register-details',
  data () {
    return {
      hasRegistered: false,
      accept: false,
      pharmacy: null,
      nameInvalid: false,
      addressInvalid: false,
      postCodeInvalid: false,
      postPlaceInvalid: false,
      isGeoReady: false
    }
  },
  methods: {
    mapReady () {
      this.isMapReady = true
    },
    onMapClick (e) {      
      this.pharmacy.latitude = e.latlng.lat
      this.pharmacy.longitude = e.latlng.lng
    },
    onDragEnd (e) {
      const latlng = e.target.getLatLng()      
      this.pharmacy.latitude = latlng.lat
      this.pharmacy.longitude = latlng.lng
      
    },
    onMapZoom () {
      this.pharmacy.zoom = this.$refs.map.mapObject.getZoom()
    },
    async doSubmit () {
      const response = await api.af.updatePharmacy(this.pharmacy)
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$router.push('/af/apotek')
      }
    },
    async onSubmit () {

      this.nameInvalid = this.pharmacy.name === ''
      this.addressInvalid = this.pharmacy.address === ''
      this.postCodeInvalid = this.pharmacy.postCode === ''
      this.postPlaceInvalid = this.pharmacy.postPlace === ''

      if (!this.nameInvalid &&
          !this.addressInvalid &&
          !this.postCodeInvalid &&
          !this.postPlaceInvalid) {
        await api.ap.updatePharmacy(this.pharmacy)
        this.$emit('submit')
      }

    }
  },
  async mounted () {
    this.pharmacy = await api.ap.getPharmacy()

    if (this.pharmacy.zoom == 0) {      
      this.pharmacy.zoom = 15
    }

    this.$nextTick(() => {
      // this.$refs.name.focus()
      this.isGeoReady = true
    })
  }
}
</script>
